import { StructuredTooltip } from './Structured';
import { SimpleTooltip } from './Simple';

export const Tooltip = {
  Simple: SimpleTooltip,
  Structured: StructuredTooltip,
};
